import React from 'react'

function WorkEx() {
  return (
    <>
    <br></br>
     <h2 className='text-6xl mt-90 ml-30 mb-8'>Experience</h2>
      <br></br>
      
      <div className="card card-compact w-88 bg-base-100 shadow-xl mt-50 ml-100 mb-8">
        <center><b><h2 className="card-title center">Site Reliability Engineer(MTS) @VMWare(Present)</h2></b></center>
            <div className="card-body">
              <ul>
              <li> <p className='text-xl'>• Working on Slack bot Automation to provide one interface for multiple tasks such as 
              posting maintenance, creating incidents, paging teams and updating Jira tickets.</p></li>
              <li> <p className='text-xl'>• Integrated bot with StatusPage API, Pagerduty API and Jira API.</p></li>
              <li> <p className='text-xl'>• Set up a Memory caching and Memory Invalidation mechanism and SQLite database using Peeewee ORM for data handling and manipulation.</p></li>
              <li> <p className='text-xl'>• Used System Design concepts like Access control layer, Memory Caching, Load Balancing etc.</p></li>
              <li> <p className='text-xl'>• Tech Stack : Python, Kubernetes, SQlite</p></li>
              </ul>
            </div>
            </div>
            <br></br> 

        <div className="card card-compact w-88 bg-base-100 shadow-xl mt-50 ml-100 mb-8">
        <center><b><h2 className="card-title center">Systems Engineer @ Tata Consultancy Services</h2></b></center>
            <div className="card-body">
              <ul>

                <li> <p className='text-xl'>• Worked on upgrading the Automated ITSM system and
                deploying it to the Web. Worked on the "MVC" structure
                and contributed in creating models and views for the
                web application.</p></li>
                <li> <p className='text-xl'>• Worked on increasing accuracy of ML models by
                implementing NLP - Stemming and lemmatization for
                better text processing of service now ticket descriptions.</p></li>
                
                <li> <p className='text-xl'>• Helping in Automating the web application by setting
                auto ticket resolving system based on past ticket analysis
                by training ML models.</p></li>
              
              </ul>
            </div>
            </div>
            <br></br>
            <div className="card card-compact w-88 bg-base-100 shadow-xl mt-50 ml-100 mb-8">
        <center><b><h2 className="card-title center">Python Project Intern @ Tata Consultancy Services</h2></b></center>
            <div className="card-body">
              <ul>

                <li> <p className='text-xl'>• Assisted in deploying Machine Learning models like Long
                        short Term Memory Layer , ARIMA and AR for creating a
                        Time Series forecasting system for forecasting Service
                        Now incidents for Business Unit.</p></li>
                <li> <p className='text-xl'>• Reduced Operational Costs and SLA breaches for
                          Business unit by automating the ITSM process by creating
                          Machine Learning models with accuracy greater than
                          85%. </p></li>
                                          
                <li> <p className='text-xl'>• Used Python, Machine Learning algorithms ARIMA, AR
                      and LSTM Neural Network to find the forecast and draw a
                      comparison between all the algorithms.
                      </p></li>
              
              </ul>
            </div>
            </div>
            <div className="card card-compact w-88 bg-base-100 shadow-xl mt-50 ml-100 mb-8">
        <center><b><h2 className="card-title center">Internshala Student Partner @ Internshala</h2></b></center>
        <div className="card-body">
              <ul>

                <li> <p className='text-xl'>• Was selected to work with Internshala from university. Promoted and Enrolled students to multiple internships
                and courses offered by Internshala.</p></li>
              
              </ul>
            </div>
            </div>
      
        
  
    </>
    
  )
}

export default WorkEx